"use client";
import React, { useEffect, useState } from "react";
import { useAppContext } from "../../app-context/provider";
import ClientOnly from "~/ui/components/ClientOnly";
import { useCart } from "~/components/cart/useCart";
import BasketIcon from "~/assets/basketIcon.svg";
import Link from "~/bridge/ui/Link";
import Image from "next/image";

export const BasketButton = ({}) => {
  const cart = useCart();
  const { path } = useAppContext();
  const [isClient, setIsClient] = useState(false);

  //resolve hydration mismatch
  useEffect(() => {
    setIsClient(true);
  }, []);

  return (
    <Link
      to={path("/checkout")}
      className="icon-link p-2 rounded-full relative"
    >
      {/* <Image
        className="w-[30px] h-[30px] max-w-none"
        src={BasketIcon}
        width="25"
        height="25"
        alt="Basket icon"
      /> */}
      <svg
        className="icon-basket w-[30px] h-[30px] max-w-none"
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-label="Basket icon"
      >
        <path
          d="M18.7802 7.08062H13.1487C12.9227 7.08062 12.7059 7.16983 12.5461 7.32863C12.3863 7.48743 12.2965 7.70281 12.2965 7.92739C12.2965 8.15197 12.3863 8.36735 12.5461 8.52615C12.7059 8.68495 12.9227 8.77416 13.1487 8.77416H18.7802C18.8509 8.77355 18.9209 8.78844 18.9851 8.81776C19.0494 8.84709 19.1063 8.89013 19.1519 8.94383C19.1975 8.99752 19.2306 9.06055 19.2488 9.12841C19.2671 9.19627 19.27 9.26729 19.2575 9.33642L17.9655 15.4908C17.9462 15.6017 17.8881 15.7024 17.8014 15.7749C17.7147 15.8474 17.605 15.8871 17.4917 15.8871H11.9692C11.8559 15.8871 11.7462 15.8474 11.6595 15.7749C11.5728 15.7024 11.5147 15.6017 11.4954 15.4908L9.61027 4.70965C9.57229 4.51837 9.46853 4.34617 9.31677 4.22258C9.16502 4.09898 8.97472 4.03169 8.7785 4.03223H4.88552C4.75565 4.03233 4.62753 4.06191 4.51094 4.11872C4.39434 4.17553 4.29235 4.25807 4.21276 4.36003C4.13317 4.46198 4.07808 4.58066 4.0517 4.707C4.02532 4.83334 4.02835 4.964 4.06056 5.089C4.11236 5.2761 4.22583 5.44053 4.38281 5.55598C4.53978 5.67142 4.7312 5.73121 4.92642 5.72578H8.08308L9.82844 15.7787C9.91629 16.2806 10.1787 16.736 10.57 17.0653C10.9613 17.3947 11.4565 17.577 11.9692 17.5806H17.4917C18.0068 17.5802 18.5053 17.3993 18.8993 17.0697C19.2934 16.7401 19.5579 16.2829 19.6461 15.7787L20.9381 9.62094C20.9917 9.30889 20.9761 8.98897 20.8923 8.68354C20.8086 8.37811 20.6587 8.09453 20.4532 7.85261C20.2477 7.61069 19.9915 7.41627 19.7026 7.28293C19.4136 7.14959 19.0988 7.08054 18.7802 7.08062V7.08062Z"
          fill="#FFFFFF"
        />
        <path
          d="M16.4339 11.8227C16.6599 11.8227 16.8766 11.7335 17.0365 11.5747C17.1963 11.4159 17.2861 11.2005 17.2861 10.9759C17.2861 10.7513 17.1963 10.536 17.0365 10.3772C16.8766 10.2184 16.6599 10.1292 16.4339 10.1292H13.7067C13.4807 10.1292 13.2639 10.2184 13.1041 10.3772C12.9443 10.536 12.8545 10.7513 12.8545 10.9759C12.8545 11.2005 12.9443 11.4159 13.1041 11.5747C13.2639 11.7335 13.4807 11.8227 13.7067 11.8227H16.4339Z"
          fill="#FFFFFF"
        />
        <path
          d="M12.3433 20.9676C13.0022 20.9676 13.5364 20.4369 13.5364 19.7822C13.5364 19.1274 13.0022 18.5967 12.3433 18.5967C11.6843 18.5967 11.1501 19.1274 11.1501 19.7822C11.1501 20.4369 11.6843 20.9676 12.3433 20.9676Z"
          fill="#FFFFFF"
        />
        <path
          d="M17.1157 20.9676C17.7747 20.9676 18.3088 20.4369 18.3088 19.7822C18.3088 19.1274 17.7747 18.5967 17.1157 18.5967C16.4568 18.5967 15.9226 19.1274 15.9226 19.7822C15.9226 20.4369 16.4568 20.9676 17.1157 20.9676Z"
          fill="#FFFFFF"
        />
        <path
          d="M16.6045 13.6854C16.6045 13.4608 16.5147 13.2454 16.3549 13.0866C16.195 12.9278 15.9783 12.8386 15.7522 12.8386H14.0478C13.8218 12.8386 13.605 12.9278 13.4452 13.0866C13.2853 13.2454 13.1956 13.4608 13.1956 13.6854C13.1956 13.91 13.2853 14.1254 13.4452 14.2842C13.605 14.443 13.8218 14.5322 14.0478 14.5322H15.7522C15.9783 14.5322 16.195 14.443 16.3549 14.2842C16.5147 14.1254 16.6045 13.91 16.6045 13.6854V13.6854Z"
          fill="#FFFFFF"
        />
      </svg>

      {isClient && (
        <ClientOnly>
          {cart.quantity > 0 && (
            <div className="basket__notification absolute rounded-full flex justify-center items-center">
              {cart.quantity}
            </div>
          )}
        </ClientOnly>
      )}
    </Link>
  );
};
